<template>
  <card class="card" title="Información de software">
    <div class="card text-center">
      <div class="card-header">
        <h2>Smart Backups v2.0.1</h2>
      </div>
      <div class="card-body">
        <h5 class="card-title">Información de Licencia de eGas Central</h5>
        <br/>
        <img
          class="avatar"
          src="@/assets/img/logo.png"
          width="50px"
          height="50px"
          alt="..."
        />
        <br/>
        <br/><p class="card-text">Derechos de Autor © {{getYear}} eGas</p>
      </div>
      <div class="card-footer text-muted">
        <a href="https://www.egas.com.mx/docs/PrivacidadEGas.pdf" target="_blank">Aviso deprivacidad</a> | eGas ® | Todos los derechos reservados
      </div>
    </div>
  </card>
</template>
<script>
export default {
  computed: {
    getYear () {
      const today = new Date();
      const year = today.getFullYear();
      return year;
    }
  },
  data() {
    return {
      user: {
        company: "eGas",
        username: "",
        email: "",
        firstName: "Chet",
        lastName: "Faker",
        address: "Melbourne, Australia",
        city: "Melbourne",
        postalCode: "",
        aboutMe: `We must accept finite disappointment, but hold on to infinite hope.`,
      },
    };
  },
  methods: {
    updateProfile() {
      alert("Your data: " + JSON.stringify(this.user));
    },
  },
};
</script>
<style>
.card-user .avatar {
  margin-top: 56px;
  width: 50px !important;
  height: 50px !important;
}
</style>
